<template>
  <div class="columns is-multiline">
    <div class="column is-full-mobile is-6">
      <window title="Basic - Input">
        <b-field label="Name">
          <b-input v-model="name"></b-input>
        </b-field>

        <b-field label="Email" type="is-danger" message="This email is invalid">
          <b-input type="email" value="john@" maxlength="30">
          </b-input>
        </b-field>

        <b-field label="Username" type="is-success" message="This username is available">
          <b-input value="johnsilver" maxlength="30"></b-input>
        </b-field>

        <b-field label="Password">
          <b-input type="password" value="iwantmytreasure" password-reveal>
          </b-input>
        </b-field>

        <b-field label="Textarea">
          <b-input maxlength="200" type="textarea"></b-input>
        </b-field>
      </window>
      <window title="With Material Design Icons">
        <b-field>
          <b-input placeholder="Search..." type="search" icon="magnify">
          </b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Email" type="email" icon="email">
          </b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Credit card" icon="credit-card">
          </b-input>
        </b-field>
      </window>
       <window title="With FontAwesome">
        <b-field>
          <b-input placeholder="Search..." type="search" icon-pack="fas" icon="search">
          </b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Email" type="email" icon-pack="fas" icon="envelope">
          </b-input>
        </b-field>
        <b-field>
          <b-input placeholder="Credit card" icon-pack="fas" icon="credit-card">
          </b-input>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="Types and states - Input">
        <h3 class="subtitle">Types and states</h3>
        <b-field>
          <b-input placeholder="No label"></b-input>
        </b-field>

        <b-field label="Rounded">
          <b-input placeholder="No label" rounded></b-input>
        </b-field>

        <b-field label="Success" type="is-success">
          <b-input placeholder="Success"></b-input>
        </b-field>

        <b-field label="Error" type="is-danger" message="You can have a message too">
          <b-input placeholder="Error"></b-input>
        </b-field>

        <b-field label="Info" type="is-info">
          <b-input placeholder="Info"></b-input>
        </b-field>

        <b-field label="Warning" type="is-warning">
          <b-input placeholder="Warning"></b-input>
        </b-field>

        <b-field label="Disabled">
          <b-input placeholder="Disabled" disabled></b-input>
        </b-field>

        <b-field label="Loading">
          <b-input placeholder="Loading" loading></b-input>
        </b-field>
      </window>
      <window title="Automatic HTML5 validation on-blur">
        <b-field>
          <b-input placeholder="Email" type="email"></b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Number" type="number" min="10" max="20">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="URL" type="url"></b-input>
        </b-field>

        <b-field>
          <b-input type="textarea" minlength="10" maxlength="100"
            placeholder="Maxlength automatically counts characters"
          >
          </b-input>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="Password" height="100%">
        <b-field>
          <b-input type="password" placeholder="Regular password input">
          </b-input>
        </b-field>

        <b-field>
          <b-input type="password" placeholder="Password reveal input" password-reveal>
          </b-input>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="Sizes" height="100%">
        <b-field>
          <b-input placeholder="Small" size="is-small" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Default" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Medium" size="is-medium" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Large" size="is-large" icon="account">
          </b-input>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="List suggestions when actived" height="100%">
        <b-field label="Password">
          <b-input type="password" placeholder="Regular password input">
          </b-input>
        </b-field>

        <b-field label="Retype Password">
          <b-input type="password" placeholder="Password reveal input" password-reveal>
          </b-input>
        </b-field>
      </window>
    </div>
    <div class="column is-full-mobile is-6">
      <window title="List suggestions on input">
        <b-field>
          <b-input placeholder="Small" size="is-small" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Default" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Medium" size="is-medium" icon="account">
          </b-input>
        </b-field>

        <b-field>
          <b-input placeholder="Large" size="is-large" icon="account">
          </b-input>
        </b-field>
      </window>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'John',
      links: [],
      state1: '',
      state2: '',
    };
  },
  methods: {
    querySearch(queryString, cb) {
      const results = queryString
        ? this.links.filter(this.createFilter(queryString))
        : this.links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return link => (
        link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      );
    },
    loadAll() {
      return [
        { value: 'vue', link: 'https://github.com/vuejs/vue' },
        { value: 'element', link: 'https://github.com/ElemeFE/element' },
        { value: 'cooking', link: 'https://github.com/ElemeFE/cooking' },
        { value: 'mint-ui', link: 'https://github.com/ElemeFE/mint-ui' },
        { value: 'vuex', link: 'https://github.com/vuejs/vuex' },
        { value: 'vue-router', link: 'https://github.com/vuejs/vue-router' },
        { value: 'babel', link: 'https://github.com/babel/babel' },
      ];
    },
    handleSelect(/* item */) {
      // console.log(item)
    },
  },
  mounted() {
    this.links = this.loadAll();
  },
};
</script>
